function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.57 9.44c1.08-.23 1.7-1.62 1.4-3.1-.33-1.5-1.46-2.5-2.54-2.28-1.08.23-1.7 1.62-1.4 3.1.33 1.5 1.46 2.5 2.54 2.28zm4.86 0c1.08.23 2.2-.8 2.53-2.27.3-1.5-.3-2.88-1.4-3.1-1.07-.24-2.2.78-2.52 2.26-.3 1.5.3 2.88 1.4 3.1zm2.7 3.95c.94.54 2.26.12 2.95-1 .7-1.1.5-2.48-.43-3.07-.94-.58-2.26-.16-2.96.96-.7 1.1-.5 2.5.4 3.07zm-10.48 0c.93-.6 1.13-2 .43-3.1s-2-1.55-2.95-.97C3.2 9.93 3 11.3 3.7 12.4c.7 1.13 2 1.55 2.93.97zm7.65-1.6c-.54-.8-1.37-1.33-2.3-1.33-.96 0-1.8.54-2.35 1.4-.6.94-1.32 2.74-2.2 3.4-1.3 1-1.94 1.94-1 3.9.26.55.7 1.03 1.25 1.32 1.02.53 2.03.57 2.9.3a3.97 3.97 0 012.8 0c.87.27 1.88.23 2.9-.3.54-.3 1-.78 1.26-1.35.9-1.9.32-2.84-.95-3.84-.9-.7-1.62-2.54-2.3-3.52z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationDogPark = function SvgLocationDogPark(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationDogPark;